export function contactsDropDown() {
    let $jsContactsWrap = $('.js--contacts__wrap'),
        jsContacts = ".js--contacts",
        jsIconPhone = ".js--icon--phone";

    $(jsIconPhone).on('click', function () {
        $jsContactsWrap.fadeToggle( "fast", "linear" );
    });

    $(document).on('click', function (e) {
        if (!e.target.closest(jsContacts) && (window.screen.width <= 991)) {
            $jsContactsWrap.fadeOut( "fast", "linear" );
        }
    });
}


// WEBPACK FOOTER //
// ./private/blocks/contacts/contacts.js